import { Card, Skeleton } from '@/components/ui';

export function BalticPreviewSkeleton() {
  return (
    <Card noPadding className="overflow-hidden shadow-sm">
      <div className="border-b border-gray-200 bg-gray-100/70 px-2 py-1.5 dark:border-dark-700 dark:bg-dark-800/80 sm:px-3 sm:py-2">
        <div className="flex gap-0.5 sm:gap-1">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-7 flex-1 rounded-md sm:h-8" />
          ))}
        </div>
      </div>
      <div className="divide-y divide-gray-100 dark:divide-dark-700">
        {Array.from({ length: 4 }).map((_, idx) => (
          <div key={idx} className="space-y-1 px-2 py-1.5 sm:px-3 sm:py-2">
            <div className="space-y-1">
              <Skeleton className="h-4 w-16 sm:h-5" />
              <Skeleton className="h-3 w-full max-w-[12rem]" />
            </div>
            <div className="grid grid-cols-[1fr_1fr_auto] items-end gap-x-2">
              <Skeleton className="h-11 rounded-md sm:h-12" />
              <Skeleton className="h-11 rounded-md sm:h-12" />
              <Skeleton className="h-7 w-[3.25rem] shrink-0 rounded sm:h-8 sm:w-16" />
            </div>
            <Skeleton className="h-2.5 w-full max-w-[12rem]" />
          </div>
        ))}
      </div>
    </Card>
  );
}
